import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-0 font-mono text-lg font-medium text-gray-800" }
const _hoisted_2 = { class: "-mt-3 text-sm italic font-normal text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    key: _ctx.post.id,
    class: "flex flex-col px-4 py-2 transition duration-500 bg-pink-100 border cursor-pointer hover:bg-white",
    to: _ctx.to
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.post.title), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.post.created.format("Do MMM")), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}